import {useABTest} from "@pg-mono/ab-testing";
import {trackAmplitudeExperimentExposure, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {
    UNLOCK_CHOICE_AB_TEST_ID,
    UNLOCK_CHOICE_CONTROL_VARIANT,
    UNLOCK_CHOICE_TREATMENT_VARIANT,
    unlockChoiceAbTest
} from "../../ab_testing/unlock_choice_ab_test";

type UnlockChoiceVariant = typeof UNLOCK_CHOICE_CONTROL_VARIANT | typeof UNLOCK_CHOICE_TREATMENT_VARIANT;

interface IUseUnlockChoiceExperimentParams {
    isEnabled: boolean;
}

interface IUnlockChoiceExperiment {
    /** The test has settled - either a variant is assigned or the user has no assignment at all */
    isResolved: boolean;
    /** The user has a control or treatment assignment */
    isAssigned: boolean;
    isTreatment: boolean;
    /** Reports the exposure of an assigned user to the data layer and Amplitude, does nothing otherwise */
    trackExposure: () => void;
}

const isUnlockChoiceVariant = (variant: string | null): variant is UnlockChoiceVariant =>
    variant === UNLOCK_CHOICE_CONTROL_VARIANT || variant === UNLOCK_CHOICE_TREATMENT_VARIANT;

export const useUnlockChoiceExperiment = ({isEnabled}: IUseUnlockChoiceExperimentParams): IUnlockChoiceExperiment => {
    const {canABTestBeRendered, abTestVariant} = useABTest({
        id: UNLOCK_CHOICE_AB_TEST_ID,
        variants: unlockChoiceAbTest.variants,
        withSSR: unlockChoiceAbTest.withSSR,
        disableEventPush: true
    });
    const variant = canABTestBeRendered && isUnlockChoiceVariant(abTestVariant) ? abTestVariant : null;
    const isAssigned = variant !== null;

    const trackExposure = () => {
        if (!isEnabled || variant === null) {
            return;
        }

        useABTest.dataLayerQueue.pushEvent({id: UNLOCK_CHOICE_AB_TEST_ID, variant, pushOnlyOnce: true});

        void waitForAmplitudeInitialization()
            .catch(() => undefined)
            .finally(() => trackAmplitudeExperimentExposure(UNLOCK_CHOICE_AB_TEST_ID));
    };

    return {
        isResolved: canABTestBeRendered,
        isAssigned,
        isTreatment: variant === UNLOCK_CHOICE_TREATMENT_VARIANT,
        trackExposure
    };
};
import {useABTest} from "@pg-mono/ab-testing";
import {trackAmplitudeExperimentExposure, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {
    UNLOCK_CHOICE_AB_TEST_ID,
    UNLOCK_CHOICE_CONTROL_VARIANT,
    UNLOCK_CHOICE_TREATMENT_VARIANT,
    unlockChoiceAbTest
} from "../../ab_testing/unlock_choice_ab_test";

type UnlockChoiceVariant = typeof UNLOCK_CHOICE_CONTROL_VARIANT | typeof UNLOCK_CHOICE_TREATMENT_VARIANT;

interface IUseUnlockChoiceExperimentParams {
    isEnabled: boolean;
}

interface IUnlockChoiceExperiment {
    /** The test has settled - either a variant is assigned or the user has no assignment at all */
    isResolved: boolean;
    /** The user has a control or treatment assignment */
    isAssigned: boolean;
    isTreatment: boolean;
    /** Reports the exposure of an assigned user to the data layer and Amplitude, does nothing otherwise */
    trackExposure: () => void;
}

const isUnlockChoiceVariant = (variant: string | null): variant is UnlockChoiceVariant =>
    variant === UNLOCK_CHOICE_CONTROL_VARIANT || variant === UNLOCK_CHOICE_TREATMENT_VARIANT;

export const useUnlockChoiceExperiment = ({isEnabled}: IUseUnlockChoiceExperimentParams): IUnlockChoiceExperiment => {
    const {canABTestBeRendered, abTestVariant} = useABTest({
        id: UNLOCK_CHOICE_AB_TEST_ID,
        variants: unlockChoiceAbTest.variants,
        withSSR: unlockChoiceAbTest.withSSR,
        disableEventPush: true
    });
    const variant = canABTestBeRendered && isUnlockChoiceVariant(abTestVariant) ? abTestVariant : null;
    const isAssigned = variant !== null;

    const trackExposure = () => {
        if (!isEnabled || variant === null) {
            return;
        }

        useABTest.dataLayerQueue.pushEvent({id: UNLOCK_CHOICE_AB_TEST_ID, variant, pushOnlyOnce: true});

        void waitForAmplitudeInitialization()
            .catch(() => undefined)
            .finally(() => trackAmplitudeExperimentExposure(UNLOCK_CHOICE_AB_TEST_ID));
    };

    return {
        isResolved: canABTestBeRendered,
        isAssigned,
        isTreatment: variant === UNLOCK_CHOICE_TREATMENT_VARIANT,
        trackExposure
    };
};
